export enum AppRole {
  CONFIGURAR_PERFIL = 'ConfigurarPerfil',
  CAMBIAR_CLAVE = 'CambiarClave',
  SIMULAR_OBJETIVO_AHORRO = 'SimularObjetivoAhorro',
  DEFINIR_OBJETIVO_AHORRO = 'DefinirObjetivoAhorro',
  CONSULTAR_OBJETIVO_AHORRO = 'ConsultarObjetivoAhorro',
  MODIFICAR_OBJETIVO_AHORRO = 'ModificarObjetivoAhorro',
  CONSULTAR_MOVIMIENTOS_OBJETIVO_AHORRO = 'ConsultarMovimientosObjetivoAhorro',
  CONSULTAR_BALANCE_AHORROS = 'ConsultarBalanceAhorros',
  CREAR_METODO_PAGO = 'CrearMetodoPago',
  CONSULTAR_METODO_PAGO = 'ConsultarMetodoPago',
  MODIFICAR_METODO_PAGO = 'ModificarMetodoPago',
  CONSULTAR_ESTADO_CUENTA = 'ConsultarEstadoCuenta',
  REALIZAR_APORTE_EXTRAORDINARIO = 'RealizarAporteExtraordinario',
  SOLICITAR_RETIRO = 'SolicitarRetiro',
}
